import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { organizerShortcut } from '@radevents/shared';
import { useOrganizerPortal } from '../../contexts/OrganizerPortalContext';

/**
 * Verweis in den Veranstalter-Bereich, oben auf der Startseite — nur für Konten, die mindestens
 * einen Veranstalter pflegen.
 *
 * Vorher führte der Weg über das Profil oder den Punkt „Veranstalter" in der Kopfleiste; beides
 * findet nur, wer schon weiß, wo er suchen muss. Ziel ist die Tür `/veranstalter-bereich`: sie
 * leitet bei einem Veranstalter direkt weiter und fragt bei mehreren, welcher.
 *
 * Eigene Leiste unter der Kopfzeile statt eines Elements im Hero: der Hero ist auf Phones
 * ausgeblendet, der Verweis soll aber gerade dort sichtbar sein.
 */
const OrganizerShortcutBanner: React.FC = () => {
  const { organizers, loading } = useOrganizerPortal();
  const shortcut = loading ? null : organizerShortcut(organizers);
  if (!shortcut) return null;

  return (
    <>
      <style>{`
        .osb { display:flex; align-items:center; gap:16px; padding:12px 40px; background:#FFF;
          border-bottom:1px solid #E5E1E1; color:#2C2C2C; text-decoration:none; }
        .osb:hover .osb-cta, .osb:focus-visible .osb-cta { background:#7A2449; }
        .osb:focus-visible { outline:2px solid #922C57; outline-offset:-2px; }
        .osb-text { flex:1; min-width:0; }
        .osb-detail { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
        @media (max-width:900px) { .osb { padding:10px 18px; } }
      `}</style>
      <Link to="/veranstalter-bereich" className="osb" data-testid="organizer-shortcut">
        <span aria-hidden style={{
          width: 10, height: 10, background: '#922C57', transform: 'rotate(45deg)', borderRadius: 2, flexShrink: 0,
        }} />
        <span className="osb-text">
          <span style={{ display: 'block', fontFamily: "'Space Mono',monospace", fontSize: 11, letterSpacing: '0.12em', color: '#615C5C' }}>
            {shortcut.eyebrow}
          </span>
          <span style={{ display: 'block', fontFamily: "'Archivo',sans-serif", fontWeight: 800, fontSize: 16, lineHeight: 1.25 }}>
            {shortcut.title}
          </span>
          <span className="osb-detail" style={{ display: 'block', fontFamily: "'Hanken Grotesk',sans-serif", fontSize: 13, color: '#615C5C' }}>
            {shortcut.detail}
          </span>
        </span>
        <span className="osb-cta" style={{
          flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 4,
          background: '#922C57', color: '#FFF', borderRadius: 999, padding: '8px 12px 8px 16px',
          fontFamily: "'Hanken Grotesk',sans-serif", fontWeight: 700, fontSize: 14,
        }}>
          {shortcut.cta}<ChevronRight size={16} aria-hidden />
        </span>
      </Link>
    </>
  );
};

export default OrganizerShortcutBanner;
